import URLSearchParams from 'url-search-params'

const validateQueryParameters = {
  'q': (value) => Array.isArray(value) ? value[0] : value,
  'dateIn': (value) => Array.isArray(value) ? value[0] : value,
  'nbNight': (value) => {
    const returnValue = Array.isArray(value) ? value[0] : value;
    return parseInt(returnValue) > 0 ? returnValue : null;
  },
  'hotel_id': (value) => Array.isArray(value) ? value[0] : value,
  'apartment_id': (value) => Array.isArray(value) ? value[0] : value,
};

/**
 * @param newQuery - URL query string
 * @param oldQuery - URL query string
 * @param keys - left this field undefined if you need to check all url query parameters
 * @param cb - function to run if url parameters was updated
 * @returns {bool} - return true if at least one of url parameters was updated
 */
const urlParamUpdated = function ({newQuery, oldQuery, keys}, cb) {
  if (typeof oldQuery !== 'string' || typeof newQuery !== 'string') return
  const newQueryData = new URLSearchParams(newQuery)
  const oldQueryData = new URLSearchParams(oldQuery)
  let resp

  if (keys) {
    resp = keys.some(function (key) {
      return newQueryData.getAll(key).toString() !== oldQueryData.getAll(key).toString()
    })
  } else {
    const keys = [
      ...newQueryData.entries(),
      ...oldQueryData.entries(),
    ].reduce((reducer, el) => {
      reducer[el[0]] = el[1]
      return reducer
    }, {})
    resp = Object.keys(keys).some(function (key) {
      return newQueryData.getAll(key).toString() !== oldQueryData.getAll(key).toString()
    })
  }

  return resp ? (cb ? cb(resp) : resp) : resp
}

const urlParamToObject = function (urlQuery) {
  const queryData = new URLSearchParams(urlQuery)
  return [...queryData.keys()].reduce((reducer, key) => {
    const values = queryData.getAll(key)
    return {
      ...reducer,
      [key]: values.length > 1 ? values : values?.[0]
    }
  }, {})
}

const objectToUrlParam = function (urlObject) {
  const urlData = new URLSearchParams()
  Object.keys(urlObject).forEach(function (key) {
    const value = urlObject[key]
    if (Array.isArray(value)) {
      value.forEach(function (val) {
        urlData.append(key, val)
      })
    } else {
      urlData.append(key, value)
    }
  })
  const queryString = urlData.toString()
  return queryString.length ? '?' + queryString : ''
}

const cleanUrlParam = function (urlQuery) {
  const queryData = urlParamToObject(urlQuery)
  Object.keys(queryData).forEach(function (key) {
    const value = queryData[key]
    const validatedValue = key in validateQueryParameters ? validateQueryParameters[key](value) : value;

    if (validatedValue) {
      queryData[key] = validatedValue
    } else {
      delete queryData[key]
    }
  })
  return objectToUrlParam(queryData)
}

const mergeSearchParams = (url, params) => {
  const paramsObj = urlParamToObject(params)

  Object.keys(paramsObj).forEach((key) => {
    const value = paramsObj[key];
    url.searchParams.delete(key)
    if (Array.isArray(value)) {
      value.forEach(val => url.searchParams.append(key, val))
    } else {
      url.searchParams.append(key, value)
    }
  })

  return url
}

export {
  urlParamUpdated,
  urlParamToObject,
  cleanUrlParam,
  mergeSearchParams,
}
